import {useEffect, useState} from 'react';

/**
 * Перерисовывает компонент раз в секунду, пока isActive. Для отсчетов, где
 * сам момент берется при отрисовке (Date.now() + поправка часов сервера), —
 * счетчик лишь будит отрисовку, поэтому после паузы отсчет сразу верный.
 * Пока отсчета нет, таймер не заводится.
 *
 * @param {boolean} isActive
 */
export const useSecondTick = (isActive) => {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!isActive) return undefined;
    const intervalId = setInterval(() => setTick((tick) => tick + 1), 1000);
    return () => clearInterval(intervalId);
  }, [isActive]);
};
